import { Link, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import axiosClient from "../../../../config/axios.js";
import TypeServiceFields from './formTypeServices/typeServiceFields'; 
import React, { useState, useEffect } from 'react';

function NewTypeService() {
  const [selectedProductKey, setSelectedProductKey] = useState(null);
  const [selectedUnitKey, setSelectedUnitKey] = useState(null);

  const navigate = useNavigate();
  const { Formik } = formik;

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/catalogs/type-services">Tipos de Servicio</Link>
            </li>
            <li className="breadcrumb-item active">Nuevo Tipo de Servicio</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nuevo Tipo de Servicio
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de nuevo Tipo de Servicio</PanelHeader>
            <PanelBody>
              <Formik
                validationSchema={yup.object().shape({
                  type_service_name: yup
                    .string()
                    .required("Ingrese el nombre del Tipo de Servicio"),
                })}

                initialValues={{
                  type_service_name: "",
                  productKey: null,
                  unitKey: null,
                }}

                onSubmit={(values, { setSubmitting }) => {
                  const selected = selectedProductKey;
                  const selectedUnit = selectedUnitKey;
                  //console.log("selected ", selected);
                 
                  if (selected === null || typeof selected !== "object" || !selected.id) {
                    return Swal.fire(
                      "Atención",
                      "Selecciona una clave de producto válida",
                      "warning"
                    );
                  }

                  if (selectedUnit === null || typeof selectedUnit !== "object" || !selectedUnit.id) {
                    return Swal.fire(
                      "Atención",
                      "Selecciona una clave de unidad válida",
                      "warning"
                    );
                  }

                  const payload = {
                    ...values,
                    id_productKey: selected.idKey,
                    id_unitKey: selectedUnit.idKey,
                  };

                  setSubmitting(false);
                  axiosClient
                    .post("/typeServices/save", payload)
                    .then((response) => {
                      Swal.fire({
                        title: "Registro exitoso.",
                        text: "Se ha registrado el nuevo Tipo de Servicio.",
                        icon: "success",
                        confirmButtonText: "Cerrar",
                      });
                      navigate("/catalogs/type-services");
                    })
                    .catch((err) => {
                      let message = "";
                      if (err.response?.data?.original?.code === "23505") {
                        message =
                          "El nombre del Tipo de Servicio ya existe. Ingresa uno diferente.";
                      } else {
                        message =
                          err.response?.data?.message ||
                          "Ocurrió un error inesperado.";
                      }
                      Swal.fire({
                        title: "Ups!",
                        text: message,
                        icon: "error",
                        confirmButtonText: "Cerrar",
                      });
                    });
                }}
              >
                {({ handleSubmit, handleChange, values, errors, touched }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <TypeServiceFields
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                      selectedProductKey={selectedProductKey}
                      setSelectedProductKey={setSelectedProductKey}
                      selectedUnitKey={selectedUnitKey}
                      setSelectedUnitKey={setSelectedUnitKey}
                    />

                    <Row className="mb-3">
                      <Col md="12">
                        <Button type="submit">Guardar Tipo de Servicio</Button>{" "}
                        <Link
                          to={"/catalogs/type-services"}
                          className="btn btn-info"
                        >
                          Cancelar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default NewTypeService;
